import { cn } from '@sohanemon/utils';
import * as React from 'react';

export type LabelProps = React.ComponentProps<'span'> & {
	/** Element to render (dt, h3, span…). */
	as?: React.ElementType;
	/** Dim further for secondary readouts. */
	faint?: boolean;
};

/**
 * Console label: mono, uppercase, wide-tracked — the chrome voice of the
 * design system (JetBrains Mono 0.625rem, 0.15em tracking).
 */
export function Label({ as, className, faint = false, ...props }: LabelProps) {
	const Comp = as ?? 'span';

	return React.createElement(Comp, {
		className: cn(
			'font-mono text-2xs text-muted-foreground uppercase tracking-widest',
			faint && 'text-muted-foreground/70',
			className,
		),
		...props,
	});
}
